var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DefaultLoading',{attrs:{"message":"页面加载中..."}})
}
var staticRenderFns = []

export { render, staticRenderFns }